import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { api } from "@/lib/api";

const fallback = [
  "Original-Qualität", "Deutschlandweiter Versand", "6 Monate Garantie (OLED)",
  "iPhone 11 bis 16 Pro Max", "Einsenden & Zurück", "Faire Festpreise",
  "1–3 Tage gesamt", "Versicherter Rückversand",
];

export default function MarqueeStrip() {
  const [items, setItems] = useState(fallback);

  useEffect(() => {
    api.get("/content").then((r) => {
      if (Array.isArray(r.data?.marquee_items) && r.data.marquee_items.length) setItems(r.data.marquee_items);
    }).catch(() => {});
  }, []);

  return (
    <div
      data-testid="marquee"
      className="border-y border-white/10 bg-[#0a0a0a] py-6 relative z-10"
    >
      <Marquee speed={40} gradient gradientColor="#0a0a0a" gradientWidth={120}>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-2xl sm:text-3xl text-white/80 px-10">{t}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-white/30" />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
